import apiClient from "./apiClient";

const PublicationService = {

    fetchAll: async () => {
        try {
            const response = await apiClient.get(`/publications`)
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    } 

}

export default PublicationService;